module.exports = new Promise((resolve, reject) => {
  const remoteUrl = "https://inspiring-mochi-553f64.netlify.app/remoteEntry.js";
  const maxAttempts = 3;

  const load = (attempt) => {
    const script = document.createElement('script');
    script.src = remoteUrl;
    script.async = true;
    script.onload = () => {
      const container = window.agenda;
      if (!container) {
        reject(new Error('Loading script failed. ' + remoteUrl));
        return;
      }
      resolve({
        get: (request) => container.get(request),
        init: (arg) => {
          try {
            return container.init(arg);
          } catch {
            console.warn('agenda remote already initialized');
          }
        },
      });
    };
    script.onerror = () => {
      script.remove();
      if (attempt + 1 < maxAttempts) {
        setTimeout(() => load(attempt + 1), 1000 * (attempt + 1));
        return;
      }
      reject(new Error('Loading script failed. ' + remoteUrl));
    };
    document.head.appendChild(script);
  };

  load(0);
});